import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import Swal from "sweetalert2";
import { Subject } from "rxjs";
import { PedidoInterface } from "app/module/pedido-interface";
import moment from "moment";
import { FechamentoService } from "app/services/fechamento.service";
import { AuthenticationService } from "app/auth/service";
import { PERFIS_FINANCEIRO } from "app/auth/helpers/perfil.guard";

@Component({
	selector: 'app-listar-fechamento',
	templateUrl: './listar-fechamento.component.html',
	styleUrls: ['./listar-fechamento.component.scss']
})
export class ListarFechamentoComponent implements OnInit {
	constructor(
		private fechamentoService: FechamentoService,
		private cdr: ChangeDetectorRef,
		private authenticationService: AuthenticationService
	) {
		this._unsubscribeAll = new Subject();
		// Vendas e Boletos só para Administrador Geral, Administrador e Financeiro (também validado na API).
		this.podeVerVendas = PERFIS_FINANCEIRO.includes(this.authenticationService.perfilLogin);
	}

	podeVerVendas = false;

	private _unsubscribeAll: Subject<any>;
	private tempData = [];

	loadingPage = false;
	selectedStatus: any;
	dateOptions = {
		altInput: true,
		mode: 'single',
		altInputClass: 'form-control flat-picker flatpickr-input invoice-edit-input',
		defaultDate: moment(new Date).format('YYYY-MM-DD'),
		altFormat: "d/m/Y",
	};

	contentHeader: object;
	basicSelectedOption: number = 10;
	ColumnMode = ColumnMode;
	rows: Array<PedidoInterface> | any = [];
	temp: Array<PedidoInterface> | any = [];

	@ViewChild(DatatableComponent) table: DatatableComponent;
	@ViewChild("tableRowDetails") tableRowDetails: any;
	async ngOnInit() {
		try {

		} catch (error) {

		} finally {
			this.cdr.detectChanges();
		}
		this.loadingPage = true;
		this.contentHeader = {
			headerTitle: "Fechamentos",
			actionButton: false,
			breadcrumb: {
				type: "",
				links: [
					{
						name: "Início",
						isLink: false,
					},
					{
						name: "Fechamento",
						isLink: false,
					},
				],
			},
		};

		await this.fechamentoService.findAll().subscribe(
			(res) => {
				this.rows = res.data
				this.temp = res.data
				this.tempData = this.rows
				this.loadingPage = false;
			},
			(error) => {
				console.log(error);
				this.msgErroInterno();
			}
		);
	}

	msgErroInterno() {
		this.loadingPage = false;
		Swal.fire({
			title: "Erro!",
			text: "Ocorreu um erro interno.",
			icon: "error",
			confirmButtonText: "Confirmar",
			confirmButtonColor: '#ef6767',
		});
	}

	ngAfterContentChecked() {
		this.rows = [...this.rows];
	}

	dateFilter(event) {
		const val = event.target.value.toLowerCase();
		const [day, month, year] = val.split("/");
		const result = [year, month, day].join("-");
		if (val.length < 10) {
			this.rows = this.temp;
		}
		if (val.length == 10) {
			// filter our data
			const temp = this.temp.filter(function (d) {
				return d.dt_insert.substring(0, 10).toLowerCase().indexOf(result) !== -1 || !result;
			});
			// update the rows
			this.rows = temp;
			// Whenever the filter changes, always go back to the first page
			this.table.offset = 0;
		}
	}

	textFilter(event, param) {
		const val = event.target.value.toLowerCase();
		// filter our data
		const temp = this.temp.filter(function (d) {
			return d[param].toLowerCase().indexOf(val) !== -1 || !val;
		});
		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		// this.table.offset = 0;
	}

	confirmDeleteAlert(data) {
		Swal.fire({
			title: "Confirmação",
			text: "Deseja excluir o item?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Excluir",
			cancelButtonText: "Cancelar",
			customClass: {
				confirmButton: "btn btn-danger",
				cancelButton: "btn btn-primary ml-1",
			},
		}).then((result) => {
			if (result.isConfirmed) {
				// return this.pedidoService.delete(1, data).subscribe(
				// 	(res) => {
				// 		Swal.fire({
				// 			title: "Sucesso!",
				// 			text: "O item foi excluído.",
				// 			icon: "success",
				// 			confirmButtonText: "Confirmar",
				// 		}).then((result) => {
				// 			if (result.isConfirmed) {
				// 				this.pedidoService.get().subscribe(
				// 					(res) => (this.rows = res),
				// 					(error) => error
				// 				);
				// 			}
				// 		});
				// 	},
				// 	(error) => {
				// 		Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
				// 	}
				// );
			}
		});
	}

}
